import { render, staticRenderFns } from "./historique-visites-medicales.html?vue&type=template&id=20673a93&scoped=true&external"
import script from "./historique-visites-medicales.js?vue&type=script&lang=js&external"
export * from "./historique-visites-medicales.js?vue&type=script&lang=js&external"
import style0 from "./historique-visites-medicales.scss?vue&type=style&index=0&id=20673a93&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20673a93",
  null
  
)

export default component.exports